// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `th {
  min-width: 7em;
}
th:first-child {
  min-width: 4em;
  text-align: center;
}

tr > td:first-child {
  text-align: center;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm9mZmVyLXRvLWFzc2lzdC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGNBQUE7QUFDRjtBQUFFO0VBQ0UsY0FBQTtFQUNBLGtCQUFBO0FBRUo7O0FBRUE7RUFDRSxrQkFBQTtBQUNGIiwiZmlsZSI6Im9mZmVyLXRvLWFzc2lzdC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbInRoIHtcbiAgbWluLXdpZHRoOiA3ZW07XG4gICY6Zmlyc3QtY2hpbGQge1xuICAgIG1pbi13aWR0aDogNGVtO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgfVxufVxuXG50ciA+IHRkOmZpcnN0LWNoaWxkIHtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/components/casi-management/offer-to-assist/offer-to-assist.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AAAE;EACE,cAAA;EACA,kBAAA;AAEJ;;AAEA;EACE,kBAAA;AACF;AACA,4hBAA4hB","sourcesContent":["th {\n  min-width: 7em;\n  &:first-child {\n    min-width: 4em;\n    text-align: center;\n  }\n}\n\ntr > td:first-child {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
